// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { headerShipToAddressStyles } from "@awc/Overrides/Widgets/Common/HeaderShipToAddress";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { color, xScreen } from "@awc/XDL/Utilities";
import { css } from "styled-components";

headerShipToAddressStyles.titleClickable = {
    css: css`
        padding-left: 12px;
        max-width: 250px;
        padding-right: 12px;
        border-right: 1px solid ${color("common.ui3")};
        min-height: 36px;
        ${xScreen("lte", "md")} {
            max-width: 120px;
        }
        ${xScreen("lte", "sm")} {
            padding: 9px 12px;
            min-height: 39px;
            border-left: 1px solid ${color("common.ui3")};
            max-width: 42px;
        }
        &:focus {
            background-color: ${color("common.ui15")};
        }
    `,
};

headerShipToAddressStyles.titleIcon = {
    size: 14,
    color: "primary.main",
    css: css`
        &,
        svg {
            width: 12px;
        }
        ${xScreen("lte", "sm")} {
            &,
            svg {
                width: 17px;
                height: 20px;
            }
        }
    `,
};

headerShipToAddressStyles.titleTypography = {
    css: css`
        margin-left: 8px;
        ${xScreen("lte", "sm")} {
            display: none;
        }
    `,
    size: fontConfig.fontSize.small,
    weight: fontConfig.weight.bold,
    lineHeight: fontConfig.lineHeight.singleLineSmall,
    color: "primary.main",
    ellipsis: true,
    transform: "none",
};

headerShipToAddressStyles.modal = {
    sizeVariant: "small",
};
